var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ArrayNotEmpty, IsArray, IsBoolean, IsOptional, IsString, IsUUID } from 'class-validator';
/**
 * Body of `POST /v1/office-locations/:officeLocationId/gkv-billing-run` — starts
 * a §302 Abrechnungslauf over the Fälle the operator left standing
 * (TM-9538 / #1519).
 *
 * ⚠ **The selection arrives as Fälle, already collapsed.** The Kandidatenbaum
 * lets a human deselect a whole Empfänger or a whole Kostenträger, but the
 * server must not re-derive what that meant: the tree it would re-derive from
 * is a second read, and between the two reads a Verordnung can have finished.
 * The leaf is the Verordnung, so the leaf is what is sent.
 *
 * ⚠ **A Fall the operator deselected is not simply absent from this list at the
 * other end** — the run records it as an item with `skip_reason = 'abgewählt'`,
 * so it stays visible afterwards that a human took it out rather than a rule.
 */
export class ExecuteGkvBillingRunDto {
    treatmentPlanIds;
    /**
     * The Stichtag the candidate list was assembled with — Leistungstage on or
     * before this date. Omitted means today, exactly as on the candidates
     * endpoint. `YYYY-MM-DD`; a future date is allowed, because a Stichtag is a
     * line through a calendar and not a payment-trust horizon.
     */
    cutoff;
    /**
     * A Probelauf — every Nutzdatendatei forced to `UNB.0035 = T` (TM-9538 / #1523).
     *
     * ⚠ **Not a preview and not a dry run.** The files it produces are real, land
     * in dakota's Übergabeverzeichnis and are processed by the Kasse as Testdaten;
     * the transport counters burn exactly as they do for any other run. What it
     * does *not* do is draw from the real Rechnungsnummern-Serie or write
     * Anspruchszeilen, so the same Fälle can be billed for real afterwards.
     *
     * ⚠ **One-directional: it can force `T` and never `E`.** Omitting it means
     * *„was die Kasse sagt"*, which is Erprobung wherever no Verfahrensstand says
     * otherwise. There is deliberately no field that forces Echtbetrieb — that
     * would be a way to skip a Kasse's Erprobung.
     */
    isTestRun;
}
__decorate([
    IsArray(),
    ArrayNotEmpty(),
    IsUUID('all', { each: true }),
    __metadata("design:type", Array)
], ExecuteGkvBillingRunDto.prototype, "treatmentPlanIds", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], ExecuteGkvBillingRunDto.prototype, "cutoff", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], ExecuteGkvBillingRunDto.prototype, "isTestRun", void 0);
/** Response of the start endpoint — the id the status poll and the cancel use. */
export class ExecuteGkvBillingRunResponseDto {
    gkvBillingRunId;
}
//# sourceMappingURL=execute-gkv-billing-run.dto.js.map